//utils
import InputText from "./InputText.js";
import InputSelect from "./InputSelect.js";
import InputCheckbox from "./InputCheckbox.js";
import Button from "./Button.js";
import TextBlock from "./TextBlock.js";
import InputPhone from "./InputPhone.js";
import InputSpinner from "./InputSpinner.js";
import InputDate from "./InputDate.js"
import InputRadio from "./InputRadio.js";
import TextInline from "./TextInline.js";
import DataCardRadio from "./DataCardRadio.js";
import TwinButtonCard from "./TwinButtonCard.js";
import CenterButtonCard from "./CenterButtonCard.js";
import BannerBtn from "./BannerBtn.js";
import QuoteCard from "./QuoteCard.js";
import QuoteCarousel from "./QuoteCarousel.js";
import Alert from "./Alert.js";
import InputRange from "./InputRange.js";
import ComboBox from "./InputComboBox.js";
import InlineErrorText from "./InlineErrorText.js";

//components
import IntroZip from "../IntroZip.js";
import altAddress from "../altAddress.js"
import Ads from "../Ads.js";
import CarrierRadio from "../CarrierRadio.js";
import Consent from "../Consent.js";
import InputCoverageSelector from "../InputCoverageSelector.js";
import HomePrefill from "../HomePrefill.js";
import modal from "../modal.js";
import petSummaryCard from "../petSummaryCard.js";

const template = `
    <div>
        <component :is="'div'" v-if="input.type === 'html-content'" v-html="input.content" :iuid="iuid"/>
        <component v-else :is="typePrefix" :iuid="iuid"/>
    </div>
`;

export default {
    name: 'b-input-renderer',
    template,
    props: ['iuid', 'img'],
    components: {
        'b-text': InputText,
        'b-select': InputSelect,
        'b-checkbox': InputCheckbox,
        'b-button': Button,
        'b-text-block': TextBlock,
        'b-intro-zip': IntroZip,
        'b-phone': InputPhone,
        'b-date': InputDate,
        'b-spinner': InputSpinner,
        'b-alt-address': altAddress,
        'b-radio': InputRadio,
        'b-alert': Alert,
        'b-text-inline': TextInline,
        'b-data-card-radio': DataCardRadio,
        'b-twin-button-card': TwinButtonCard,
        'b-center-button-card': CenterButtonCard,
        'b-carrier-radio': CarrierRadio,
        'b-banner-btn': BannerBtn,
        'b-quote-card': QuoteCard,
        'b-quote-carousel': QuoteCarousel,
        'b-coverage-select': InputCoverageSelector,
        'b-home-prefill': HomePrefill,
        'b-input-range': InputRange,
        'b-combobox': ComboBox,
        'b-modal': modal,
        'b-consent': Consent,
        'b-inline-error-text': InlineErrorText,
        'b-ads': Ads,
        'b-pet-summary': petSummaryCard
    },
    computed: {
        typePrefix: function () {
            var elType = 'b-text';
            const bTxts = ['hidden', 'number', 'email', 'cc', 'cvv'];
            // console.log(this.input.type, this.input.uid);
            if (bTxts.indexOf(this.input.type) == -1) {
                elType = `b-${this.input.type}`;
            }
            return elType;
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        }
    },
    methods: {

    }
};
